import ChooseOptionView from './Modals/TransportModalViews/ChooseOptionView';
import ChooseDateTimeView from './Modals/TransportModalViews/ChooseDateTimeView';

export const customer_details_titles = ['Name', 'Phone', 'Email', 'Country', 'City', 'County', 'Street', 'Post Code', 'Preferred contact method', 'Preferred contact time', 'Preferred Collection Date'];
export const customer_details_keys = ['full_name', 'phone', 'email', 'country', 'city', 'county', 'street', 'post_code', 'preferred_contact_method', 'preferred_contact_time', 'customer_collection_date'];
export const cap_valuation_titles = ['Retail', 'Clean', 'Avg.', 'Poor'];
export const mot_titles = ['Date Tested', 'Expires', 'Mileage', 'Result'];
export const vrm_titles = ['Abbr', 'Date', 'Valuation', 'Retail', 'By', 'Status'];
export const valuation_titles = ['Date', 'Valuation', 'Retail', 'Division'];
export const stock_report_titles = ['VRM', 'Bike', 'Mileage', 'Purchased', 'Retail', 'DIS'];
export const preferred_contact_method = ['Any', 'Telephone', 'Email', 'SMS'];
export const time_picker_options = [
    '09:00 - 10:00',
    '10:00 - 11:00',
    '11:00 - 12:00',
    '12:00 - 13:00',
    '13:00 - 14:00',
    '14:00 - 15:00',
    '15:00 - 16:00',
    '16:00 - 17:00',
    '17:00 - 18:00',
    '18:00 - 19:00',
    '19:00 - 20:00',
];

export const send_email_options_no_price = [
    { value: 'Tried To Call', template_id: 2 },
    { value: 'Wrong Number Supplied', template_id: 1 },
];
export const send_sms_options = [
    { value: 'Offer Sms', template_id: 1 },
    { value: 'Amended Offer SMS', template_id: 2 },
    { value: 'Tried to Call SMS', template_id: 3 },
    { value: 'Trade SMS', template_id: 7 },
    { value: 'Request Photos', template_id: 8 },
];
export const send_sms_options_with_confirm = [
    { value: 'Offer Sms', template_id: 1 },
    { value: 'Amended Offer SMS', template_id: 2 },
    { value: 'Tried to Call SMS', template_id: 3 },
    { value: 'Delivery Confirmation', template_id: 4 },
    { value: 'Trade SMS', template_id: 7 },
    { value: 'Request Photos', template_id: 8 },
];
export const data_transport_modal = [
    { iconType: 'fa fa-clock', title: 'Exact Time' },
    { iconType: 'fas fa-calendar-day', title: 'Exact Day' },
    { iconType: 'fas fa-calendar-week', title: 'Range of Days' },
];
export const active_transport_option = 'bookingOption active';
export const inactive_transport_option = 'bookingOption inactive';
export const transport_option_title_active = 'active';
export const transport_option_title_inactive = 'inactive';
export const steps = [ChooseOptionView, ChooseDateTimeView];
export const photos_types_styles = {
    heading: {
        fontSize: 16,
        backgroundColor: '#f7fdff',
        paddingLeft: 20,
        marginBottom: 10,
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
    },
    default: {
        margin: 20,
        fontStyle: 'italic',
    },
};
export const photo_types = ['Driver', 'Advert', 'Blemish Report', 'Settlement Documents'];
export const rangeHoursFrom = [0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23];
export const rangeHoursTo = [0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23];
export const tHoursFrom = [0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23];
export const tHoursTo = [0, 1, 2, 3, 4, 5, 6, 7, 8, 20, 21, 22, 23];


export const positiveStatusesFromArrangeDelivery = [
    // arrange Collection
    '5c4837e08109b9f96e847a49',
    // transport arranged
    '5c8615197e203773e8886802',
    // bought
    '5c8784c947f99d83281b350d',
    // collection canceled
    '5c87845747f99d83281b350c',
    // collection confirmed
    '5c87838c47f99d83281b350b',
    // driver canceled
    '5c87850f47f99d83281b350e',

    // arrange Collection (trade)
    '5f8574fcd88a9007b68aa736',
    // transport arranged (trade)
    '5f85820bd88a9007b68aa739',
    // bought (trade)
    '5c8784c947f99d83281b350d',
    // collection canceled (trade)
    '5f858829d88a9007b68aa73c',
];



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/statics.js